import { Directive, Input, HostListener } from '@angular/core';
import { ConfirmModalService } from '../services/confirm-modal.service';

@Directive({
	selector: 'a[sm-image-preview]'
})
export class SmImagePreviewDirective {
	@Input() href: string;

	constructor(private _confirm: ConfirmModalService) { }

	@HostListener('click', ['$event'])
	onClick(e: any) {
		e.preventDefault();

		this._confirm.content(
			`<img src="${this.href}" class="img-fluid" alt=""/>`,
			{ windowClass: 'sm-image-preview', size: 'lg' });
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/directives/sm-image-preview.directive.ts